/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProposalPolicyPage = lazyLoad(
  () => import('./index'),
  module => module.ProposalPolicyPage
);
